import fetchCustomerAccessToken from './fetchCustomerAccessToken'
import { loadState, saveState } from '../utils/localStorage'

const saveCustomerAccessToken = saveState('customerAccessToken')

const loadCustomerAccessToken = async client => {
  const customerAccessToken = loadState('customerAccessToken')
  if (!customerAccessToken || Date.parse(customerAccessToken.expiresAt) < new Date()) {
    const newAccessToken = await fetchCustomerAccessToken(client)

    if (newAccessToken != null) {
      saveCustomerAccessToken(newAccessToken)
    }

    return newAccessToken
  }
  return customerAccessToken
}

export default loadCustomerAccessToken
